<script setup>
import BaseText from "@/library/BaseText.vue";
</script>

<template>
  <BaseText
    as="h2"
    variant="headline-3-bold"
  >
    <slot />
  </BaseText>
</template>
